// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2+ySl";
export var navigationList = "footer-module--navigation-list--WegDK";